import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Settings, Container, List } from 'lucide-react';
import VehiclesRecords from '@/components/vehicles/VehiclesRecords';
import ProcurementContainers from '@/components/vehicles/ProcurementContainers';
import VehicleSheet from '@/components/vehicles/VehicleSheet';
import SbtImportSheet from '@/components/vehicles/SbtImportSheet';
import ManageProcurementSheet from '@/components/vehicles/ManageProcurementSheet';
import SyncTransactionsSheet from '@/components/vehicles/SyncTransactionsSheet';

export default function VehiclesProcurementPage() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const [selectedVehicleId, setSelectedVehicleId] = useState<number | null>(null);

  const [manageOpen, setManageOpen] = useState(false);
  const [importSheetOpen, setImportSheetOpen] = useState(false);
  const [syncTxnOpen, setSyncTxnOpen] = useState(false);
  const [view, setView] = useState<'containers' | 'list'>('containers');

  const viewToggle = (
    <Tabs value={view} onValueChange={(val) => setView(val as 'containers' | 'list')}>
      <TabsList>
        <TabsTrigger value="containers">
          <Container className="h-4 w-4 mr-1.5" />
          Containers
        </TabsTrigger>
        <TabsTrigger value="list">
          <List className="h-4 w-4 mr-1.5" />
          List
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );

  return (
    <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-4xl font-semibold tracking-tight mb-2">Procurement</h1>
          <p className="text-muted-foreground">Track vehicles through the procurement pipeline.</p>
        </div>
        <Button onClick={() => setManageOpen(true)}>
          <Settings className="h-4 w-4 mr-1" />
          Manage
        </Button>
      </div>

      {view === 'containers'
        ? <ProcurementContainers controlsExtra={viewToggle} />
        : <VehiclesRecords group="procurement" controlsExtra={viewToggle} />}

      <VehicleSheet
        open={sheetOpen}
        onOpenChange={setSheetOpen}
        vehicleId={selectedVehicleId}
      />

      <ManageProcurementSheet
        open={manageOpen}
        onOpenChange={setManageOpen}
        onSyncReservations={() => setImportSheetOpen(true)}
        onSyncTransactions={() => setSyncTxnOpen(true)}
      />

      <SbtImportSheet
        open={importSheetOpen}
        onOpenChange={setImportSheetOpen}
      />

      <SyncTransactionsSheet
        open={syncTxnOpen}
        onOpenChange={setSyncTxnOpen}
      />
    </div>
  );
}
